import script from "./main_menu.vue?vue&type=script&setup=true&lang=js"
export * from "./main_menu.vue?vue&type=script&setup=true&lang=js"

import "./main_menu.vue?vue&type=style&index=0&id=27f94a1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f94a1e"]])

export default __exports__